import './App.css';
import SchedulerPage from './Pages/ScedulerPage';

function App() {
  return (
    
    <SchedulerPage /> 
    // No routes NativeAnimationExtended, yet
  );
}

export default App;
